jQuery(function ($) {
    //    < ------------------------------------------------------>
    //Share Slider 
    //Home Slider
    $('.shareSlider').owlCarousel({
        loop: false,
        margin: 0,
        dots: true,
        nav: false,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1
            },
            420: {
                items: 1
            },
            600: {
                items: 1
            }
        }
    });
});